import type { Customer } from 'types'

export const isFrogboxCustomer = (guid?: string) => guid && guid !== '00000000-0000-0000-0000-000000000000'

export const isStreamingPassesActive = (customer?: Customer) =>
  customer?.devices?.find(device => !device.expiryDate || device.expiryDate > new Date().toISOString()) ?? false

export const getYoutubeStudioUrl = (streamUrl: string) => {
  const strMatch = streamUrl.match(/v=([^&]+)/)
  if (!strMatch || strMatch.length === 1) return '#'
  return `https://studio.youtube.com/video/${strMatch[1]}/livestreaming`
}
